<div class="input-container">
  @if (label) {
    <label class="label">{{ label }}</label>
  }

  <div
    class="input-wrapper"
    [class.error]="control && control.errors && control.touched"
    [class.focused]="shouldFocus"
    [class.highlight]="highlight"
    [ngClass]="size"
    >
    @if (control) {
      <input
        #input
        [id]="id"
        [formControl]="control"
        [type]="resolvedType"
        class="input"
        [placeholder]="placeholder || ''"
        [readOnly]="readOnly"
        [mentionConfig]="mentionConfig"
        (focus)="onFocus()"
        />
    } @else {
      <input
        #input
        [id]="id"
        [value]="initialValue || ''"
        [type]="resolvedType"
        class="input"
        [placeholder]="placeholder || ''"
        [readOnly]="readOnly"
        [mentionConfig]="mentionConfig"
        (focus)="onFocus()"
        />
    }


    @if (type === 'password') {
      <fa-icon
        class="icon clickable"
        [icon]="passwordVisible ? icons.eye : icons.eyeClosed"
        (click)="togglePasswordView()"
      ></fa-icon>
    }
  </div>
</div>
